export const TABLE_CELL_FILE_NAME = 'tableCellFileName';
export const TABLE_CELL_FILE_ACTION_DELETE = 'tableCellFileActionDelete';
export const TABLE_CELL_FILE_CREATED_AT = 'tableCellFileCreatedAt';
export const ROW_NO_FILES_UPLOADED_ID = 'rowNoFilesUploaded';
